<!--
 * @Description: 
 * @Author: git config user.name
 * @Date: 2024-07-10 10:22:22
 * @LastEditors: git config user.name
 * @LastEditTime: 2024-07-11 13:47:41
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\platform-services\components\detailDialog.vue
-->
<template>
  <el-dialog :visible.sync="visible" class="" width="1000px" :title="title" :close-on-click-modal="false"
    @closed="handleClosed" center>
    <Panel title="#1 服务信息">
      <el-form ref="serviceInfo" :model="serviceInfo" label-width="120px" class="tableForm">
        <el-form-item label="状态">
          {{ serviceInfo.effectiveStatus }}
        </el-form-item>
        <el-form-item label="服务类型">
          <div v-if="serviceInfo.payType == 0">平台技术服务费（包年）</div>
        </el-form-item>
        <el-form-item label="服务有效期">
          <div>{{ serviceInfo.expirationDate }}

          </div>
        </el-form-item>
      </el-form>
    </Panel>
    <Panel title="#2 享受权益">
      <el-table ref="xTable" highlight-current-row :data="tableData" min-height="230px" class="mt10" border>
        <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
        <el-table-column prop="rightsType" label="权益类型" header-align="center" width="160"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="rightsContent" label="权益内容" header-align="center" min-width="200"
          show-overflow-tooltip></el-table-column>
      </el-table>
    </Panel>
    <Panel title="#3 支付信息">
      <el-form ref="infoForm" :model="infoForm" label-width="120px" class="tableForm">
        <el-form-item label="开通人">
          <div>{{ infoForm.createUser }}</div>
        </el-form-item>
        <el-form-item label="开通单位">
          <div>{{ infoForm.tenantName }}</div>
        </el-form-item>
        <el-form-item label="开通时间">
          <div>{{ infoForm.openTime }}</div>
        </el-form-item>
        <el-form-item label="支付金额">
          <el-input v-model="infoForm.money" disabled>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
    </Panel>

    <Panel title="#4 关闭记录" v-if="!showClose">
      <el-form ref="closeForm" :model="closeForm" label-width="120px" class="tableForm">
        <el-form-item label="服务关闭时间">
          <div>{{ closeForm.closeTime }}</div>
        </el-form-item>
        <el-form-item label="关闭原因">
          <div>{{ closeForm.closeReason }}</div>
        </el-form-item>
        <el-form-item label="操作人">
          <div>{{ closeForm.createUser }}</div>
        </el-form-item>
        <el-form-item label="操作时间">
          <div>{{ closeForm.createDate }}</div>
        </el-form-item>
      </el-form>
    </Panel>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { getServiceFeeDetail } from "api/modules/templateConfiguration";
import Panel from "@/components/panel/Panel";
export default {
  components: { Panel },
  filters: {
    timeFilter(val) {
      if (val) {
        return val.split(" ")[0];
      }
    },
  },
  data() {
    return {
      visible: false,
      btnLoading: false,
      title: "服务详情",
      infoForm: {},
      serviceInfo: {}, //
      tableData: [],
      closeForm: {},// 关闭记录
      showClose: false, // 是否显示关闭记录
    };
  },
  methods: {
    //详情接口
    getDetail(id) {
      getServiceFeeDetail({ id: id })
        .then((res) => {

          this.tableData = res.data.serviceRights;
          // 服务信息
          this.serviceInfo = res.data.serviceInfo;
          // 支付信息
          this.infoForm = res.data.payInfo; //

          // 关闭记录
          this.closeForm = res.data.closeInfo;

          // 是否显示关闭记录
          this.showClose = Object.keys(this.closeForm).length === 0;

          // 关闭时间数据处理
          if (this.closeForm && this.closeForm.closeTime) {
            this.closeForm.closeTime = this.closeForm.closeTime.slice(0, 10);
          }
        })
        .catch((err) => { });
    },

    handleClosed() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form {
  &.tableForm {
    .el-form-item {
      margin-bottom: 0;
      margin-right: 0;
      display: flex;
    }

    .el-form-item__label {
      width: 200px;
      // border: 0;
      border: 1px solid #dcdcdc;
      border-right: 0;
      border-bottom: 0;
      line-height: 46px;
      // margin: 0 1px;
      background: #fafafa;
      padding-right: 20px;
    }

    .el-form-item__content {
      border: 1px solid #dcdcdc;
      border-bottom: 0;
      width: calc(100% - 110px);
      background-color: #fff;
      line-height: 46px;
      text-align: left;
      margin-left: 0 !important;
      padding-left: 20px;
    }

    .el-form-item:last-child {

      .el-form-item__content,
      .el-form-item__label {
        border-bottom: 1px solid #dcdcdc;
      }
    }

    .el-input {
      width: 100%;
    }

    .el-input__inner {
      min-height: 46px !important;
      line-height: 46px !important;
      padding-left: 0px;
      border: 0;
      border-radius: 0;
    }

    .vxe-switch {
      padding-left: 20px;
    }

    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border: 1px solid #ccc;
    }

    .el-date-editor .el-input__inner {
      padding-left: 30px;
    }

    .el-form-item.is-error .el-input__inner,
    .el-form-item.is-error .el-input__inner:focus,
    .el-form-item.is-error .el-textarea__inner,
    .el-form-item.is-error .el-textarea__inner:focus {
      border: 1px solid #f56c6c;
    }

    .el-select {
      width: 100%;
    }

    .el-switch,
    .el-checkbox-group,
    .el-radio-group {
      margin-left: 20px;
    }

    .el-textarea__inner {
      border: none;
      border-radius: 0;
      padding-left: 20px;
    }

    .el-textarea .el-input__count {
      background-color: rgba(255, 255, 255, 0);
      bottom: -10px;
    }

    .el-textarea__inner:focus {
      border: 1px solid #dcdcdc;
      outline: none;
      border-color: #409eff;
    }

    .el-cascader {
      width: 100%;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      background-color: #f4f7fa;
      color: #666;
      border-color: transparent;
    }
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
  }
}
</style>